export enum CoreProductGrouping {
  StandaloneProduct,
  AnalyticalProduct,
  DataCollectionProduct,
}
